export const HELPDESK_SET_CITIES = "HELPDESK/SET_CITIES_TO_STATE";
export const HELPDESK_SET_CITY = "HELPDESK/SET_CITY_TO_STATE";
